import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Host1, HttpHeaderToken } from '../general/variables';
import { Fur } from '../models/Fur';
import { FrmFURPorCodigoBorrador } from '../models/FrmFURPorCodigoBorrador';
import { LoginMovil } from '../models/LoginMovil';

@Injectable({
  providedIn: 'root'
})

export class FurService {

  constructor(protected http: HttpClient) { }

  // tslint:disable-next-line: ban-types
  url: String = `${Host1}`;

  RegistrarFur(fur: Fur) {
    return this.http.post<Fur>(`${this.url}/api/v1/denuncia/registrarDenuncia`, fur, HttpHeaderToken());

  }

  ActualizarFur(fur: Fur) {

    // console.log(fur);

    return this.http.post<Fur>(`${this.url}/fur/actualizarFurExt`, fur, HttpHeaderToken());


  }

  ObtenerFurPorCodigo(codFur: string) {

    return this.http.get<Fur>(`${this.url}/fur/obtenerFurPorCodigo/${codFur}`, HttpHeaderToken());



  }

  // ObtenerFurPorId(idFur:number) {

  //   return this.http.get<Fur>(`${this.url}/fur/obtenerFurPorId/${idFur}`,HttpHeaderToken());

  // }

  ObtenerPlantillaFurPorId(idFur: number) {

    return this.http.get<Fur>(`${this.url}/plantilla/obtenerPlantillaFurPorId/${idFur}`, HttpHeaderToken());

  }

  obtenerFurPorCodigoBorrador(frmFURPorCodigoBorrador: FrmFURPorCodigoBorrador) {

    // console.log("frmFURPorCodigoBorrador");
    // console.log(frmFURPorCodigoBorrador);
    // console.log(HttpHeaderToken());

    return this.http.post<Fur>(`${this.url}/fur/obtenerFurPorCodigoBorrador`, frmFURPorCodigoBorrador, HttpHeaderToken());

  }


  regenerarClaveDenunciaFur(frmFURPorCodigoBorrador: FrmFURPorCodigoBorrador) {

    // console.log("frmFURPorCodigoBorrador");
    // console.log(frmFURPorCodigoBorrador);

    return this.http.post<Fur>(`${this.url}/fur/regenerarClaveDenunciaFur`, frmFURPorCodigoBorrador, HttpHeaderToken());

  }

  obtenerFurPorLoginMovil(loginMovil: LoginMovil) {

    // console.log("====olvidoClave");
    // console.log(loginMovil);

    return this.http.post<Fur>(`${this.url}/movil/obtenerFurPorLogin`, loginMovil, HttpHeaderToken());

  }


}
